export default [{
   value: 'custom',
   name: 'Custom',
   backgroundColor: '#ecf7f9',
   highlightColor: '#bfe4eb'
}, {
   value: 'inherit',
   name: 'Automatic',
   backgroundColor: '#ecf7f9',
   highlightColor: '#bfe4eb'
}, {
   value: 'private',
   name: 'Private',
   backgroundColor: '#ecf4f9',
   highlightColor: '#bfe4eb'
}, {
   value: 'admin',
   name: 'Admin-Only',
   backgroundColor: '#fffbe8',
   highlightColor: '#f9d790'
}, {
   value: 'draft',
   name: 'Draft Mode',
   backgroundColor: '#fffbe8',
   highlightColor: '#f7dfad'
}]
